import React, { useEffect, useRef, useState } from "react";
import heroVideo from "../../images/bg/Semiconductor AI video_Web Launch video_03.mp4";
import heroMobileVideo from "../../images/bg/hero-mobile.mp4";
import heroPoster from "../../images/bg/hero-video-poster.jpg";
import "./Hero.css";

const HeroSection: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [playing, setPlaying] = useState(false);
  const [failed, setFailed] = useState(false);

  const startVideo = () => {
    const video = videoRef.current;
    if (!video) return;
    // Set the DOM properties before play() as well as the JSX attributes for iOS.
    video.defaultMuted = true;
    video.muted = true;
    video.playsInline = true;
    void video.play().catch(() => setPlaying(false));
  };

  useEffect(() => {
    startVideo();
  }, []);

  return (
    <section className="home-video-hero" aria-label="Digicomm Semiconductor introduction">
      <div className="home-video-hero__media">
        <video
          ref={videoRef}
          className="home-video-hero__video"
          autoPlay
          muted
          loop
          playsInline
          controls={false}
          preload="auto"
          poster={heroPoster}
          onCanPlay={startVideo}
          onPlaying={() => { setPlaying(true); setFailed(false); }}
          onPause={() => setPlaying(false)}
          onError={() => { setFailed(true); setPlaying(false); }}
          aria-label="Digicomm Semiconductor - Powering Tomorrow's Silicon Solutions"
        >
          <source src={heroMobileVideo} type="video/mp4" media="(max-width: 767px)" />
          <source src={heroVideo} type="video/mp4" />
        </video>
        {!playing && (
          <img className="home-video-hero__poster" src={heroPoster}
            alt="Digicomm Semiconductor - Powering Tomorrow's Silicon Solutions" />
        )}
        {!playing && !failed && (
          <button type="button" className="home-video-hero__play" onClick={startVideo}>
            Play introduction
          </button>
        )}
      </div>
    </section>
  );
};

export default HeroSection;
